const starPath = `M6.39,13.73l-1.1,7.1,6.27-3.45L18,20.62l-1.39-7,5-5.1-7.15-.88L11.12,1.17,8,7.71,1,8.82Z`;

const USBounding = [49.3457868,-124.7844079,24.7433195,-66.9513812];

function degrees(x) {
  return x * (180/Math.PI);
}

function radians(x) {
  return x * (Math.PI/180);
}

const projection = d3.geo.albersUsa();

export class Location {
  constructor(data,ctrl) {
    this.ctrl = ctrl;
    this.model = data;
    this.siblings = [];
    this.children = data.children;
    this.state = {
      current:false,
      past:false
    }
    this.combined = false;

    this.has_issues = this.model.issues && this.model.issues.length;
    this.local = data.is_local;
    if (this.local) {
      this.parent = this.ctrl.locations.find(l => l.model.id === data.parent);
    }

    this.initView();

    //this.associateCollection(this.model.acf.partners,'partner');
    //this.associateCollection(this.model.acf.impacts,'impact');

    this.initState();
    if (this.view && this.view.group && (this.has_issues)) this.initHandlers();
  }

  combine(other) {
    other.combined = this;
    other.view.group.remove();
    this.siblings.push(other);
  }

  deconflict(locs) {
    if (this.coords && !this.combined && (this.state.past || this.state.current)) {
      const conflicts = locs.filter(other => 
        other.model.id !== this.model.id 
        && other.coords 
        && (other.state.past || other.state.current)
        && Math.abs(other.coords.x - this.coords.x) < 10 
        && Math.abs(other.coords.y - this.coords.y) < 10
      );
      conflicts.forEach(other => this.combine(other));
    }
  }

  associateChildren() {
    if (this.children) {
      this.children = this.children.map(c => {
        return this.ctrl.locations.find(l => {
          return l.model.id === c;
        })
      })
    }
  }

  // associateCollection(local,ref) {
  //   if (local && local.length) {
  //     local.forEach((item,i) => {
  //       local[i] = this.ctrl[ref].find(other => other.id === item)
  //     })
  //   }
  // }

  setState(state,on) {
    this.state[state] = on;
    if (this.view && this.view.group) {
      if (on) {
        this.view.group.classList.add(state);
      } else {
        this.view.group.classList.remove(state);
      }
    }
    if (state == 'hover') {
      const body = document.querySelector("body");
      if (on) {
        const bbox = this.view.group.getBoundingClientRect();
        const x = bbox.x + (bbox.width/2) + window.scrollX;
        const y = bbox.y + window.scrollY;
        this.view.tooltip.style.top = `${y}px`;
        this.view.tooltip.style.left = `${x}px`;
        this.view.tooltip.innerHTML = this.generateTooltipContent();
        body.appendChild(this.view.tooltip);
      } else {
        body.removeChild(this.view.tooltip);
      }
    }
    if (state == 'active') {
      if (on) {
        this.ctrl.locations.forEach(loc => {
          if (loc.model.id !== this.model.id) loc.setState("active",false)
        });
        if (this.view.content) {
          this.view.content.classList.add('active');
        }
        this.view.content.scrollIntoView();
      } else {
        if (this.view.content) this.view.content.classList.remove('active');
      }
    }
    if (this.combined) this.combined.setState("combined-active",on);
  }

  initState() {
    this.setState('past',this.model.is_past);
    this.setState('current',this.model.is_current);
    if (this.has_issues) {
      this.setState(`has-issues`,true);
      this.model.issues.forEach(issue => {
        this.setState(`issue-${issue}`,true);
      });
    }
  }

  generateTooltipContent() {
    let content = `<div class="tooltip__content ${this.siblings.length ? "has-siblings" : ""}">Learn about our work in`;
    [this].concat(this.siblings).forEach(loc => content += `<br><strong data-id="${loc.model.id}">${loc.model.title.rendered}</strong>`);
    content += `</div>`;
    return content;
  }

  initContentHandlers() {
    const items = Array.from(this.view.content.querySelectorAll(".accordion__item"));
    items.forEach(item => {
      item.querySelector(".accordion__item__header a").addEventListener("click",(e) => {
        e.preventDefault();
        item.classList.toggle("open");
      })
    })
  }

  initView() {
    this.view = {
      group: undefined,
      loc: undefined,
      label: undefined,
      tooltip: undefined,
      content: undefined
    }
    if (this.local) {
      //this.initLocalView();
    } else if (this.model.acf.abbreviation) {
      this.view.group = this.ctrl.view.map.querySelector(`[id*="${this.model.acf.abbreviation}"]`);
      this.view.loc = this.view.group.querySelector(".state");
      this.view.label = this.view.group.querySelector(".label");
    }
    this.view.tooltip = document.createElement("div");
    this.view.tooltip.classList.add("component-tooltip-national-map");

    this.view.content = this.ctrl.view.content.querySelector(`.map__location-${this.model.id}`);
    this.initContentHandlers();
  }

//   initLocalView() {
// 
//     this.view.group = document.createElementNS(this.ctrl.view.svg.namespaceURI,'g');
//     this.view.group.classList.add("local");
//     this.view.group.classList.add("local-"+this.model.title.rendered.toLowerCase().replaceAll(" ","-"));
// 
//     this.view.loc = document.createElementNS(this.ctrl.view.svg.namespaceURI,'path');
//     this.view.loc.setAttribute("d",starPath);
//     this.view.loc.classList.add("location");
// 
//     this.view.group.appendChild(this.view.loc);
//     this.ctrl.view.locals.appendChild(this.view.group);
// 
//     const coords = projection([this.model.acf.longitude,this.model.acf.latitude]);
// 
//     if (coords) {
//       this.coords = {x:coords[0],y:coords[1]};
//       this.view.group.style.transform = `translate(${this.coords.x + "px"},${this.coords.y + "px"})`;
//     } else {
//       this.view.group.remove();
//     }
//   }

  initHandlers() {

    this.view.group.addEventListener("mouseenter",() => {
      this.setState("hover",true);
    })
    this.view.group.addEventListener("mouseleave",(e) => {
      if (e.toElement != this.view.tooltip) {
        this.setState("hover",false);
      }
    })

    this.view.tooltip.addEventListener("mouseleave",() => {
      this.setState("hover",false);
    })

    this.view.group.addEventListener("click",() => {
      this.setState('active',true);
    })

    this.view.tooltip.addEventListener("click",(e) => {
      if (e.target.tagName === "STRONG" && e.target.dataset.id) {
        const loc = this.ctrl.locations.find(loc => loc.model.id == e.target.dataset.id);
        loc.setState('active',true);
      } else {
        this.setState('active',true);
      }
      
    })
  }

}